"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NotificationSettingsEdit;
const jsx_runtime_1 = require("react/jsx-runtime");
function NotificationSettingsEdit(props) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
}
